module.exports = __webpack_public_path__ + "media/templates.95cf0711.webm";